export default __webpack_public_path__ + "static/media/plus-outline.339b3d11.svg";